import { render, staticRenderFns } from "./flashSaleGoods.vue?vue&type=template&id=32d350c2&scoped=true&"
import script from "./flashSaleGoods.vue?vue&type=script&lang=js&"
export * from "./flashSaleGoods.vue?vue&type=script&lang=js&"
import style0 from "./flashSaleGoods.vue?vue&type=style&index=0&id=32d350c2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d350c2",
  null
  
)

export default component.exports